<template>
  <div class="dd-container news-container">
    <p class="title">{{$t('news')}}</p>
    <News />
  </div>
</template>

<script>
import News from '@pc/news/index'

export default {
  async fetch ({ store, app }) {
    await store.dispatch('news/getList', {
      app
    })
  },
  components: {
    News
  }
}
</script>

<style lang="scss" scoped>
.news-container {
  padding: 77px 0 67px;

  .title {
    margin-bottom: 38px;
    color: #000000;
    text-align: center;
    font-size: 24px;
  }
}
</style>
